module.exports = __webpack_public_path__ + "static/index/img/baikal-906.70cc462e.jpg";